import React, { lazy } from 'react';
import { AuthRoute } from '../auth/components';
import config from "@config";


const WidgetCalculator = lazy(() => import('./pages/WidgetCalculator'));


const calculatorsModule = {
  routes: [
    <AuthRoute
      key="stamp-duty"
      exact
      path="/calculators/stamp-duty"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Stamp duty calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'stamp-duty' }}
    />,
    <AuthRoute
      key="loan-repayment"
      exact
      path="/calculators/loan-repayment"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Loan repayment calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'loan-repayment' }}
    />,
    <AuthRoute
      key="extra-repayment"
      exact
      path="/calculators/extra-repayment"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Extra repayment calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'extra-loan-repayment' }}
    />,
    <AuthRoute
      key="income-taxes"
      exact
      path="/calculators/income-taxes"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Income tax calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'income-taxes-calculator' }}
    />,
    <AuthRoute
      key="offset-account"
      exact
      path="/calculators/offset-account"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Offset account calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'offset-account-calculator' }}
    />,
    <AuthRoute
      key="equity-calculator"
      exact
      path="/calculators/equity-calculator"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Equity calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'equity-calculator' }}
    />,
    <AuthRoute
      key="rate-change-calculator"
      exact
      path="/calculators/rate-change-calculator"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Rate change calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'rate-change-calculator' }}
    />,
    <AuthRoute
      key="income-annualisation-calculator"
      exact
      path="/calculators/income-annualisation-calculator"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Income annualisation calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'income-annualisation-calculator' }}
    />,
    <AuthRoute
      key="savings-calculator"
      exact
      path="/calculators/savings-calculator"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Savings calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'savings-calculator' }}
    />,
  ]
};

export default calculatorsModule;
